import { React} from 'react'
import { Disclosure } from "@headlessui/react";
import {ChevronDownIcon} from "@heroicons/react/outline"
const data=[
    {
      id:"1",
      imgurl:"/car.png",
      name:"Vehiculo Art",
      descrription:"To sketch a predefined vehicle object in a fine good way as Output in a 2D Structure.",
      rules:[
        {
          id:'1',
          rule:"Any kind of 2D art which is related to automobile pic."
        },
        {
          id:'2',
          rule:"Sketch Papers will be given to draw a art from our side "
        },
        {
          id:'3',
          rule:"The Drawing should be done within the respect time."
        },
        {
          id:'4',
          rule:"Other Necessary items should be brought from your side."
        }
      ]
    },
    {
      id:"2",
      imgurl:"/pp.png",
      name:"Paper Presentation",
      descrription:"To share the Futuristic technical ideas through a Paper Presentation format in a simple and humble way. Topics are @Read More",
      rules:[
        {
          id:'1',
          rule:"About Autonomous Vehicle and its Features"
        },
        {
          id:'2',
          rule:"About Fuels Cell battery"
        },
        {
          id:'3',
          rule:"How can a E-motor replace an Engine of a Heavy vehicle"
        },
        {
          id:'4',
          rule:"About Wear Technology"
        },
      ]
    },
    {
      id:"3",
      imgurl:"/engine.png",
      name:"Engine Crossfit",
      descrription:"The Most Fine Format of Engineering work through Mandling and Dismandling the Engine.",
      rules:[
        {
          id:'1',
          rule:"There will be two different type of engine .one will be assembled and another will be dismandle.the assembled engine should dismandled and the dismandled engine should be assembled within the respected time."
        }
      ]
    },
    {
        id:"4",
        imgurl:"/quiz.png",
        name:"Auto Quiz",
        descrription:"The Fun and Tricky ideological auto questions.",
        rules:[
          {
            id:'1',
            rule:"There will be two different round.At first round, The question will be individual to every person and at the second round the selected person at the first round will be grouped."
          }
        ]
      },
      {
        id:"5",
        imgurl:"/3dcar.png",
        name:"CAD Modelling and Simulation",
        descrription:"The fine peace idea of R&D work begins here.",
        rules:[
          {
            id:'1',
            rule:"In this cad modelling event 2D digrams will be give with all dimension and the given auto parts will be designed in to 3D modelling as a fine finished product."
          }
        ]
      },
      {
        id:"6",
        imgurl:"/boxcricket.png",
        name:"Box Cricket",
        descrription:"Box Cricket is a cricket sport that is played indoor or inside a boundary of the net. It is basically miniature version of cricket played for fun during leisure time.",
        rules:[
          {
            id:'1',
            rule:"No Rules"
          }
        ]
      },
      {
        id:"7",
        imgurl:"/tugowar.png",
        name:"Tug-o-war",
        descrription:"Tug of war is a sport that pits two teams against each other in a test of strength.",
        rules:[
          {
            id:'1',
            rule:"No Rules"
          }
        ]
      },
      {
        id:"8",
        imgurl:"/heardle.png",
        name:"Heardle",
        descrription:"This simple puzzle game revolves around music. More specifically, it tasks players with guessing a song based on the intro.",
        rules:[
          {
            id:'1',
            rule:"No Rules"
          }
        ]
      },
      {
        id:"9",
        imgurl:"/photography.png",
        name:"Photography",
        descrription:"Photography is the art, application, and practice of creating durable images by recording light, either electronically by means of an image sensor, or chemically by means of a light-sensitive material such as photographic film.",
        rules:[
          {
            id:'1',
            rule:"No Rules"
          }
        ]
      }
  ]

function Events() {
  return (
    <div>
    <div className='px-8 lg:px-40 pt-10 pb-6 font-Questrial text-center'>
        <div className=' text-xl sm:text-4xl md:text-4xl px-6 text-blue-900 leading-tight font-extrabold tracking-wide'>
           Events
        </div>
        <div className='grid grid-cols-1 md:grid-cols-3 md:gap-x-4 mt-2 mb-6'>
    {data.map((datas) =>(
     <div key={datas.id} className="w-full md:max-w-xs my-4 rounded-lg overflow-hidden shadow-lg">
     <img className="w-full h-48 object-center object-cover" src={datas.imgurl} alt="Sunset in the mountains"/>
      <div className="px-6 py-4">
       <div className="font-bold text-base mb-2 uppercase">{datas.name}</div>
       <p className="text-gray-700 leading-normal line-clamp-2 text-sm">
       {datas.descrription}
       </p>
      </div>
      <div className="px-6 pb-4">
       <Disclosure>
      {({ open }) => (
        <>
          <Disclosure.Button>
          <span className="flex w-full justify-between items-center py-2 px-3 text-xs font-medium text-center text-white bg-blue-700 rounded-lg focus:ring-4 focus:outline-none focus:ring-blue-300 ">
            <p>Read More </p>
            <ChevronDownIcon
              className='h-3 w-3 ml-1'
            />
          </span>
          </Disclosure.Button>
          <Disclosure.Panel className='py-2 my-2 bg-gray-100 rounded-lg'>
          {datas.rules.map((rule) =>(
          <span key={rule.id} className="flex items-center pb-1 px-3 text-xs font-medium text-center text-black focus:outline-none ">
            {rule.id}. {rule.rule}
            </span>
          ))}
            </Disclosure.Panel>
        </>
      )}
    </Disclosure>
      </div>
      </div>
      ))}
    </div>
    </div>
    
    </div>
  )
}

export default Events